import React, { useEffect, useState } from 'react'
import { FaSearch, FaList, FaPlus, FaInbox, FaCodeBranch } from "react-icons/fa";
import { useLocation } from 'react-router';
import ResourceAdminRead from './ResourceAdminRead';
import ResourceAdminCreate from './ResourceAdminCreate';
import ResourceAdminEdit from './ResourceAdminEdit';
import ResourceAdminList from './ResourceAdminList';


// 2 projects-new born support
// Teams members-No login
// resource
// one account user
function ResourceAdmin() {
      const location = useLocation()
      const [activeAction,setActiveAction] = useState(null)
    
      const navItems = [
        { label: 'Create Resource',  path: '/staff/resource/create',tab:'create-resource' },
        { label: 'Resource',  path: '/staff/resource/detail',tab:'resource-detail-view'  },
        { label: 'Edit Resource',  path: '/staff/resource/edit',tab:'edit-resource' },
        { label: 'List Resources',  path: '/staff/resources',tab:'list-resources' },
      ];
    
      
    
       useEffect(()=>{
          // console.log(location)
          if(location?.pathname==="/staff/resource/create/" && activeAction !== "create-resource"){
            setActiveAction("create-resource")
          }else if(location?.pathname.includes("/staff/resource/detail/") && activeAction !== "resource-detail-view"){
            setActiveAction("resource-detail-view")
          }else if(location?.pathname==="/staff/resource/edit/" && activeAction !== "edit-resource"){
            setActiveAction("edit-resource")
          }else if(location?.pathname==="/staff/resources/" && activeAction !== "list-resources"){
            setActiveAction("list-resources")
          }
        },[location])

         useEffect(()=>{
            if(location?.state?.redirect){
              setActiveAction(location?.state?.redirect)
            }
          },[location])
    
        const CreateArticle = (e)=>{
          e.preventDefault()
          setActiveAction("create-resource")
        }
    
        const EditArticle = (e)=>{
          e.preventDefault()
          setActiveAction("edit-resource")
        }
    
        const ListArticles = (e)=>{
          e.preventDefault()
          setActiveAction("list-resources")
        }
    
  
        const views = {
          "create-resource":<ResourceAdminCreate/>,
          "edit-resource":<ResourceAdminEdit/>,
          "resource-detail-view":<ResourceAdminRead/>,
          "list-resources": <ResourceAdminList/>
        }
  
  
    return (
      <div>
          {/* <h3>ProjectAdmin</h3> */}
      <header className="projects-header-admin">
        <h1 className="header-title-admin">Resources DashBoard</h1>
  
        <div className="header-controls-admin">
          <div className="search-container">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Type / to search"
              className="search-input"
            />
          </div>
  
          <div className="icon-group">
            <button className="icon-button tooltip-container" onClick={CreateArticle}>
              <FaPlus /> <span>New Resource</span> <span class="tooltip-content">New Resources</span>
            </button>
            <button className="icon-button tooltip-container" onClick={ListArticles}>
              <FaList /> <span>View Resources</span> <span class="tooltip-content">List All Resources</span>
            </button>
            <button className="icon-button">
              <FaCodeBranch />
            </button>
            <button className="icon-button">
              <FaInbox />
            </button>
          </div>
        </div>
      </header>
  
      <div>
          {
            views[activeAction] || views['list-resources']
          }
      </div>
      </div>
    )
}

export default ResourceAdmin